<template>
  <a-spin :spinning="spinning">
    <a-icon slot="indicator" type="loading" style="font-size: 24px" spin/>
    <slot>空页面</slot>
  </a-spin>
</template>

<script>
export default {
  name: "c-layout",
  props: {
    spinning: {
      type: Boolean,
      default: true
    },
  },
  data() {
    return {}
  },
  computed: {},
  mounted() {
    console.log(this.spinning)
  },
  methods: {
    pageLoading() {
    },
  }
}
</script>

<style scoped>

</style>
